import React, { Component, Fragment, ReactNode } from 'react';
import {
  ArchiosExpressionProfile,
  ExpressionBuilderView,
  ExpressionContextMenuComponent,
  ExpressionTokenComponent,
  GroupToken,
  StandardExpressionBuilderView,
  Syntax,
  TokenVariable,
  VariableToken,
} from '@trlogic/ui-pack';
import { generateUUIDV4 } from '../../../util/Generator';
import DataType from '../../../constant/DataType';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { query, repository } from '@trlogic/client-js';
import VariableType from 'constant/VariableType';
import ComponentUtil from '../../../util/ComponentUtil';
import ComponentName from '../../../constant/ComponentName';
import { ExpressionUtil } from '../../../util/ExpressionUtil';

class ExpressionComponent extends Component<Props, State> {
  public state: State = new State();

  private readonly repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  public render(): ReactNode {
    const { expression, expressionView } = this.state;

    return (
      <div className='bg-[#FAFAFA] border-[f-black-5] border-[0.5px] rounded-[2px] w-full' id='expression_builder'>
        {expression && expressionView && (
          <Fragment>
            <ExpressionContextMenuComponent context={expressionView.getContext()} close={this.onCloseContextMenu} />
            <ExpressionTokenComponent syntax={expressionView.getModel()} view={expressionView} />
          </Fragment>
        )}
      </div>
    );
  }

  public async componentDidMount() {
    this.buildData();
  }

  private buildData = () => {
    let expression = this.state.expression;
    let variables = this.state.variables;
    if (this.props.syntax) expression = this.props.syntax;
    if (this.props.variables) variables = this.props.variables;
    const expressionView: ExpressionBuilderView = new StandardExpressionBuilderView({
      el: '#expression_builder',
      model: expression,
      profile: new ArchiosExpressionProfile(),
      returnType: { dataType: DataType.BOOLEAN },
      onCtrlToken: ExpressionUtil.onNavigateToken,
    });
    expressionView.getContext().setVariables(variables);
    expressionView.onChange(this.onChangeSyntax as VoidFunction);
    this.setState({ expressionView, expression }, () => {
      expressionView.initialize();
      if (this.props.disabled) {
        expressionView.pause();
      }
    });
  };

  public componentWillUnmount() {
    const { expressionView } = this.state;
    expressionView?.terminate();
  }

  public async componentDidUpdate(prevProps: Readonly<Props>) {
    if (prevProps.disabled !== this.props.disabled) {
      if (this.props.disabled) {
        this.state.expressionView?.pause();
      } else {
        this.state.expressionView?.resume();
      }
    }
    if (prevProps.variableUpdated !== this.props.variableUpdated && this.state.expressionView) {
      this.state.expressionView.getContext().setVariables(this.props.variables);
    }
    if (prevProps.syntaxUpdated !== this.props.syntaxUpdated && this.state.expressionView && this.props.syntax) {
      this.state.expressionView.terminate();
      this.setState({ expression: this.props.syntax, expressionView: undefined }, () => {
        this.buildData();
      });
    }
  }

  private onChangeSyntax = (updatedExpression: Syntax): void => {
    const { onChangeSyntax } = this.props;
    this.setState({ expression: updatedExpression });
    onChangeSyntax(updatedExpression);
  };

  private onCloseContextMenu() {}
}

interface Props {
  syntax: Syntax;
  variables: Record<string, TokenVariable[]>;
  onChangeSyntax: (syntax: Syntax) => void;
  variableUpdated: number;
  syntaxUpdated: number;
  disabled?: boolean;
}

class State {
  expressionView: ExpressionBuilderView | undefined;
  variables: Record<string, TokenVariable[]> = {};
  expression: Syntax = {
    id: generateUUIDV4(),
    value: {
      type: 'TokenGroup',
      properties: { dataType: DataType.BOOLEAN },
    } as GroupToken,
    children: [],
  };
}

export default ExpressionComponent;
